'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookComments = function FacebookComments(_ref) {
    var loadFbSdk = _ref.loadFbSdk,
        buttonText = _ref.buttonText,
        commentsAlwaysOpen = _ref.commentsAlwaysOpen,
        minutesUntilClose = _ref.minutesUntilClose,
        minutesLeftWhenWarningDisplayed = _ref.minutesLeftWhenWarningDisplayed,
        url = _ref.url,
        numPosts = _ref.numPosts,
        commentsLoaded = _ref.commentsLoaded,
        theme = _ref.theme,
        widgetWidth = _ref.widgetWidth;
    return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
            'h2',
            null,
            !commentsLoaded && _react2.default.createElement(
                'button',
                {
                    onClick: function onClick() {
                        return loadFbSdk();
                    },
                    className: theme['load-comments']
                },
                buttonText
            )
        ),
        !commentsAlwaysOpen && _react2.default.createElement(
            'div',
            { className: theme['closing-info-wrapper'], 'aria-live': 'polite' },
            commentsLoaded && minutesUntilClose < minutesLeftWhenWarningDisplayed && minutesUntilClose > 0 && _react2.default.createElement(
                'div',
                { className: theme['closing-info'], role: 'alert' },
                _react2.default.createElement(
                    'p',
                    null,
                    'Kommentarfeltet stenger om',
                    ' ',
                    minutesUntilClose,
                    ' ',
                    minutesUntilClose > 1 ? 'minutter.' : 'minutt.'
                )
            )
        ),
        _react2.default.createElement('div', {
            className: 'fb-comments',
            'data-href': url,
            'data-numposts': numPosts,
            'data-width': widgetWidth
        })
    );
};

FacebookComments.propTypes = {
    loadFbSdk: _propTypes2.default.func.isRequired,
    buttonText: _propTypes2.default.string.isRequired,
    commentsAlwaysOpen: _propTypes2.default.bool.isRequired,
    url: _propTypes2.default.string.isRequired,
    minutesUntilClose: _propTypes2.default.number.isRequired,
    minutesLeftWhenWarningDisplayed: _propTypes2.default.number.isRequired,
    numPosts: _propTypes2.default.string.isRequired,
    commentsLoaded: _propTypes2.default.bool.isRequired,
    theme: _propTypes2.default.shape({
        'closing-info': _propTypes2.default.string,
        'closing-info-wrapper': _propTypes2.default.string,
        'load-comments': _propTypes2.default.string
    }).isRequired,
    widgetWidth: _propTypes2.default.string
};

FacebookComments.defaultProps = {
    widgetWidth: undefined
};

exports.default = FacebookComments;
//# sourceMappingURL=FacebookComments.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/fb-comments/lib/cjs/FacebookComments.js
 ** module id = 723
 ** module chunks = 1
 **/